import React from 'react';
import style from '../card.module.css'
function Science() {
  return (
    <div className={style.syllabus_card}>
    <div>    
        <h3>Science</h3>  
        <p>2 upcoming . 306 courses</p>      
    </div>   
    
        <p>Physics,Chemistry, Biology and more</p>      
    
    </div>
  )
}
export default Science